import {
    windCardinal,
    getDisplayValue,
    pbClass
} from '../format-display-value';

import * as DateManager from '../../../dates';

export function drawPbTable(hourlyData, chartContainer) {
    const tableHeader = $('<div style="width:100%;"></div>');
    tableHeader.append(`<hr>`);

    const vertHeaderItems = [
        'Prescribed Burn',
        'Flame Height',
        'Fuel Availability',
        'Fuel Moisture',
        'FBI',
        'Temperature',
        'Precipitation',
        'Humidity',
        'Wind Speed',
        'Wind Direction'
    ];

    const headerRow = $(`<div class="pb-table-row"></div>`)
    headerRow.append($(`<div class="pb-table-header-col-time">Time</div>`));

    vertHeaderItems.forEach((item) => {
        headerRow.append($(`<div class="pb-table-header-col vertical-text">${item}</div>`));
    });
    tableHeader.append(headerRow);
    tableHeader.append(`<hr>`);

    // Add in all the data
    chartContainer.append(tableHeader);

    console.log(hourlyData);

    let counter = 0;

    const generateColItem = (data) => {
        return `<div class="pb-table-row-col">${getDisplayValue(data, '2dp')}</div>`;
    }

    hourlyData.forEach((dataItem) => {
        if(counter % 3 == 0) {
            console.log(dataItem);

            const row = $(`<div class="pb-table-row"></div>`);

            const pbColour = pbClass(dataItem.PrescribedBurn);

            row.append(`<div class="pb-table-header-col-time">${DateManager.dateToString(new Date(dataItem.Time), 'dd/MM hh:mm')}</div>`);
            row.append(`<div class="pb-table-row-col ${pbColour}">${dataItem.PrescribedBurn}</div>`);
            row.append(generateColItem(dataItem.FlameHeight));
            row.append(generateColItem(dataItem.FuelAvailability));
            row.append(generateColItem(dataItem.FuelMoisture));
            row.append(generateColItem(dataItem.FBI));
            row.append(generateColItem(dataItem.Temperature));
            row.append(generateColItem(dataItem.Precipitation < 0 ? 0 : dataItem.Precipitation));
            row.append(generateColItem(dataItem.Humidity));
            row.append(generateColItem(dataItem.WindSpeed));
            row.append(`<div class="pb-table-row-col">${windCardinal(dataItem.WindDirection)}</div>`);

            chartContainer.append(row);
        }

        // TODO - Build the other rows

        

        counter += 1;
    })



}